import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Reveal, Magnetic } from './motion';
import VideoOverlay from './VideoOverlay';
import { CONTACT, VIDEOS, POSTERS } from '@/content/site';

export default function PageHero({ eyebrow, title, lede, children }) {
  return (
    <section className="relative overflow-hidden bg-deep">
      <div className="aura aura--emerald" style={{ width: 640, height: 640, top: -280, left: -180 }} />
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.13]"
        aria-hidden="true"
        style={{
          backgroundImage:
            'repeating-linear-gradient(115deg, transparent 0 120px, rgba(178,139,67,0.35) 120px 120.75px)',
        }}
      />
      <div className="wrap pt-40 pb-20 lg:pt-48 lg:pb-24 relative">
        <Reveal>
          <p className="eyebrow-mono">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="h1 mt-7 max-w-[22ch]">{title}</h1>
        </Reveal>
        {lede && (
          <Reveal delay={0.16}>
            <p className="lede mt-8 max-w-[58ch]">{lede}</p>
          </Reveal>
        )}
        {children}
      </div>
      <div
        className="absolute bottom-0 inset-x-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(178,139,67,0.5), transparent)' }}
      />
    </section>
  );
}

export function CtaSection({
  title,
  copy,
  buttonLabel,
  buttonTo,
  testid = 'cta-button',
  interestParam,
}) {
  const to = interestParam ? `${buttonTo}?interest=${interestParam}` : buttonTo;
  return (
    <section className="relative overflow-hidden" data-testid="cta-section">
      <VideoOverlay src={VIDEOS.gold} poster={POSTERS.gold} tint="band" />
      <div className="wrap section relative">
        <div className="max-w-3xl">
          <Reveal>
            <p className="eyebrow-mono">KTK Advisors</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h2 mt-6">{title}</h2>
          </Reveal>
          {copy && (
            <Reveal delay={0.14}>
              <p className="lede mt-6">{copy}</p>
            </Reveal>
          )}
          <Reveal delay={0.2}>
            <div className="mt-11 flex flex-wrap items-center gap-7">
              <Magnetic>
                <Link to={to} data-testid={testid} className="btn btn-gold">
                  {buttonLabel}
                  <ArrowRight size={17} />
                </Link>
              </Magnetic>
              <a
                href={CONTACT.phoneHref}
                data-testid={`${testid}-phone`}
                className="inline-flex items-center gap-3 text-[15px] font-semibold text-ivory hover:text-goldbright transition-colors"
              >
                <span className="w-9 h-px bg-goldbright/60" aria-hidden="true" />
                <Phone size={15} />
                {CONTACT.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
